import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Loader from "../../../../Common/Loader/loader";
import { VehicleWiseHookLoaderTripsReport } from "../../../../Apis/ttrReportsApi";
import CustomDataTable from "../../../../Common/ReportTable/ReportTable";
import { GetZone } from "../../../../Apis/organizationApi";
import * as XLSX from "xlsx";
import ExcelJS from "exceljs";

const Vehiclehook = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState(null);
  const [startDate, setStartDate] = useState(getStartOfCurrentDate());
  const [endDate, setEndDate] = useState(getCurrentDateTime());
  const [isOptionsLoading, setIsOptionsLoading] = useState(false);
  const [dataWithTotal, setDataWithTotal] = useState(null);
  const location = useLocation()

  useEffect(() => {
    if (location.state) {
      setData(location.state); // Set data when it's available
    } else {
      //fetchData(); // Fetch data when component mounts if state is not available
    }
  }, [location.state]);

  //   const fetchData = async (ZoneId, VehicleTypeId) => {
  //     try {
  //       setIsLoading(true);
  //       // Perform the API call again to fetch data
  //       const requestData = { Date, VehicleTypeId, ZoneId }; // Assuming these are defined somewhere
  //       const response = await innergetAllZoneWiseReport(requestData);
  //       setData(response.data);
  //     } catch (error) {
  //       console.error("Error fetching zone wise report:", error);
  //     } finally {
  //       setIsLoading(false);
  //     }
  //   };

  //const data = location.state
  const [zonesData, setZonesData] = useState([]);
  const formatDateTime = (dateTime) => {
    if (!dateTime || dateTime === "N/A") return "N/A";
    try {
      const date = new Date(dateTime);
      if (isNaN(date.getTime())) return "N/A"; // Handle invalid dates
      return date.toLocaleString("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      }).replace(/,/, "").replace(/\//g, "-"); // Format as DD-MM-YYYY HH:mm:ss
    } catch (error) {
      return "N/A"; // Handle parsing errors
    }
  };

  const ZoneContainerColumns = [
    {
      name: "Sl.No",
      selector: (row) => row["slno"],
      sortable: true,
      format: (row, rowIndex) => rowIndex + 1,
    },
    {
      name: "Zone Name",
      selector: (row) => (
        <span
        //  style={{ color: "blue", cursor: "pointer" }}
        //    onClick={() => handleVehicleClick(row["vehicleNumber"])}
        >
          {row["zoneName"]}
        </span>
      ),
      sortable: true,
    },
    {
      name: "TS Name",
      selector: (row) => (
        <span
        //  style={{ color: "blue", cursor: "pointer" }}
        //    onClick={() => handleVehicleClick(row["vehicleNumber"])}
        >
          {row["transferStationName"]}
        </span>
      ),
      sortable: true,
    },
    {
      name: "Vehicle Number",
      selector: (row) => (
        <span
        //  style={{ color: "blue", cursor: "pointer" }}
        //    onClick={() => handleVehicleClick(row["vehicleNumber"])}
        >
          {row["vehicleNumber"]}
        </span>
      ),
      sortable: true,
    },
    {
      name: "Vehicle Model",
      selector: (row) => (
        <span
        //  style={{ color: "blue" }}
        >{row["vehicleModel"]}</span>
      ),
      sortable: true,
    },
    {
      name: "Date Time IN",
      selector: (row) => row["dateTimeIn"],
      cell: (row) => (
        <span>
          {row["dateTimeIn"] && formatDateTime(row["dateTimeIn"])}
        </span>
      ),
      sortable: true,
      // width: "120px",
    },
    {
      name: "Date Time Out",
      selector: (row) => row["dateTimeOut"],
      cell: (row) => (
        <span>
          {row["dateTimeOut"] && formatDateTime(row["dateTimeOut"])}
        </span>
      ),
      sortable: true,
      // width: "120px",
    },
    {
      name: "Turn Around Time",
      selector: (row) => (
        <span
        //style={{ color: "blue" }}
        >{row["turnAroundTime"]}</span>
      ),
      sortable: true,
    },
    {
      name: "Tonnage",
      selector: (row) => (
        <span
        //style={{ color: "blue" }}
        >{row["tonnge"].toFixed(2)}</span>
      ),
      sortable: true,
    },
  ];
  useEffect(() => {
    const calculateContainerTotals = (data) => {
      const totals = {
        vehicleNumber: "",
        zoneName: "Total",
        tonnge: 0,
      };

      data.forEach((row) => {
        totals.tonnge +=  row.tonnge || 0;
      });
      return totals;
    };
    const totalZoneRow = calculateContainerTotals(location.state || []);
    const ContainerDataWithTotal = [...location.state, totalZoneRow];
    setDataWithTotal(ContainerDataWithTotal);
  }, [location.state]);

  const handleVehicleClick = async (vehicle) => {

    try {
      setIsOptionsLoading(true);
      const requestData = {
        startDate,
        endDate,
        vehicleNumber: vehicle.vehicleNumber,
      }
      const response = await VehicleWiseHookLoaderTripsReport(startDate, endDate, requestData.vehicleNumber);
      navigate("/vehicle-hookloader_report", { state: response.data });
    } catch (error) {
      console.error("Error", error);
    } finally {
      setIsOptionsLoading(false);
    }
  };


  const options = { day: 'numeric', month: 'numeric', year: 'numeric' };
  const generationTime = ` ${new Date().toLocaleString('en-GB', options).replace(/\//g, '/')}`;

  const downloadAsExcel = async () => {
    // Create a new workbook and add a worksheet
    const currentDate = new Date();
    const formattedDate = `${currentDate.getDate()}-${currentDate.getMonth() + 1
      }-${currentDate.getFullYear()}`;
    const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
    const downloadDateTime = ` Vehicle Wise Report Generated on: ${generationTime},${formattedTime}`;
    // Calculate the length of the downloadDateTime string
    const downloadDateTimeLength = downloadDateTime.length;
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Trips&Tonnage");

    // Define styles
    const boldFont = { bold: true };

    // Add the downloadDateTime to the correct row and columns, and ensure formatting
    worksheet.addRow(["", "", downloadDateTime, ""]); // Update array length to match new cell range
    worksheet.mergeCells(1, 2, 1, 4); // Merge cells for downloadDateTime from column 2 to 4
    worksheet.getCell(1, 2).value = downloadDateTime; // Ensure the value is set after merging
    worksheet.getCell(1, 2).font = boldFont; // Set font style
    worksheet.getCell(1, 2).alignment = { horizontal: "center" }; // Center align the content

    // Apply styles to the merged cells (B1, C1, D1)
    for (let col = 2; col <= 4; col++) {
      worksheet.getCell(1, col).font = boldFont; // Set styles individually
      worksheet.getCell(1, col).alignment = { horizontal: "center" }; // Center align the cell content
    }

    // Add "Zone Details" to the correct row and columns, and ensure formatting
    worksheet.addRow(["", "", "Vehicle Wise Hookloader Details", ""]); // Update array length to match new cell range
    worksheet.mergeCells(2, 2, 2, 4); // Merge cells for Zone Details from column 2 to 4
    worksheet.getCell(2, 2).value = " Vehicle Wise Hookloader Details"; // Ensure the value is set after merging
    worksheet.getCell(2, 2).font = boldFont; // Set font style
    worksheet.getCell(2, 2).alignment = { horizontal: "center" }; // Center align the content

    // Apply styles to the merged cells (B2, C2, D2)
    for (let col = 2; col <= 4; col++) {
      worksheet.getCell(2, col).font = boldFont; // Set styles individually
      worksheet.getCell(2, col).alignment = { horizontal: "center" }; // Center align the cell content
    }
    const tableHeaderRow = worksheet.addRow([
      "S.No",
      "Zone Name",
      "TS Name",
      "Vehicle Number",
      "Vehicle Model",
      "Date Time In",
      "Date Time Out",
      "Turn Around Time",
      "Tonnage"
    ]);
    tableHeaderRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
      cell.font = boldFont;
      cell.alignment = { horizontal: "left", color: "#fff" }; // Center align the cell content
      if (colNumber >= 1 && colNumber <= 9) {
        // Apply background color and set text color
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "F6B1B1" }, // Red background color
          bgColor: { argb: "FFFFFFFF" } // White text color
        };
      }
    });

    
    let totalQty = 0;
    // Add data rows
    data.forEach((item, index) => {
      totalQty += item.tonnge || 0;
      worksheet
        .addRow([
          index + 1,
          item.zoneName ?? "N/A",
          item.transferStationName ?? "N/A",
          item.vehicleNumber ?? "N/A",
          item.vehicleModel ?? "N/A",
          formatDateTime(item.dateTimeIn), // Format dateTimeIn
          formatDateTime(item.dateTimeOut), // Format dateTimeOut
          item.turnAroundTime ?? "N/A",
          item.tonnge ?? "N/A"
        ])
        .eachCell({ includeEmpty: true }, (cell, colNumber) => {
          if (colNumber >= 1 && colNumber <= 9) {
            // Align the columns from 1 to 4 to the left
            cell.alignment = { horizontal: "left" };
          } else {
            // Align the rest of the columns to the center
            cell.alignment = { horizontal: "center" };
          }
        });
    });

    // Add total row
    const totalRow = worksheet.addRow([
      "",
      'Total',
      "",
      "",
      "",
      "",
      "",
      "",
      totalQty,
    ]);
    
    totalRow.eachCell((cell) => {
        cell.font = { bold: true };
        cell.alignment = { horizontal: "left" };
    });


    // Set column widths dynamically based on content
    worksheet.columns = [
      { width: 5 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 15 },
      { width: 15 },
      { width: 15 },
      { width: 15 },
      { width: 15 },
    ];

    // Save the workbook to a file
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = " Vehicle Wise Hookloader Report.xlsx";
    a.click();
    URL.revokeObjectURL(url);
  };
  return (
    <>
      <div style={{ width: "100%" }}>
        <div className="content">
          <div className="page-content">
            <div className="page-header"></div>
            <div class="row" style={{ textAlign: "justify" }}>
            </div>
            <div className="card">
              <div className="card-body">
                <div className="d-flex justify-content-end mt-3 mb-3">
                  <button className="btn btn-secondary  me-2" style={{}}
                    onClick={() => navigate(-1)}
                  >
                    Back
                  </button>
                  <button className="btn btn-excel"
                    onClick={downloadAsExcel}
                  >
                    <i class="fa-solid fa-file-excel me-1 icon-container"></i> Excel
                  </button>

                </div>

                <div className="top-header">
                  <span>
                    {" "}
                    Vehicle Wise HookLoader Report
                  </span>
                </div>
                {data &&
                  <CustomDataTable
                    data={dataWithTotal}
                    columns={ZoneContainerColumns}
                  />
                }
              </div>
            </div>
          </div>
        </div>
      </div>
      {isLoading && <Loader />}
    </>
  );
};

export default Vehiclehook;


const getStartOfCurrentDate = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}T00:00`;
};

// Function to get current date and time in the required format
const getCurrentDateTime = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  const hour = String(now.getHours()).padStart(2, "0");
  const minute = String(now.getMinutes()).padStart(2, "0");
  return `${year}-${month}-${day}T${hour}:${minute}`;
};